const FieldSelector = (props) => {
	const { children } = props;

	return children;
};

export default FieldSelector;
